import MeetingMessageActionEntrySource from '../store/schema/MeetingMessageActionEntrySource';
import MeetingCancellationMessageType from 'owa-service/lib/contract/MeetingCancellationMessageType';
import { action } from 'satcheljs';

export default action(
    'removeCancelledMeetingFromCalendar',
    (item: MeetingCancellationMessageType, entrySource: MeetingMessageActionEntrySource) => ({
        item,
        entrySource,
    })
);
